import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { pushSupported, isIosNotInstalled, getPushSubscription, enablePush, disablePush } from "@/lib/push";

/** Carte « Notifications push » (profil) : activation réelle Web Push (Android / iOS PWA installée). */
export const PushSettings = () => {
  const [supported] = useState(pushSupported());
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [devices, setDevices] = useState(0);
  const iosHint = isIosNotInstalled();

  useEffect(() => {
    (async () => {
      try {
        const sub = await getPushSubscription();
        setEnabled(!!sub && Notification.permission === "granted");
        const { data } = await api.get("/push/status");
        setDevices(data.devices || 0);
      } catch (e) {}
    })();
  }, []);

  const toggle = async (v) => {
    setBusy(true);
    try {
      if (v) {
        await enablePush();
        toast.success("Notifications push activées sur cet appareil");
      } else {
        await disablePush();
        toast("Notifications push désactivées");
      }
      setEnabled(v);
      const { data } = await api.get("/push/status");
      setDevices(data.devices || 0);
    } catch (e) {
      toast.error(e?.message || apiError(e));
    } finally {
      setBusy(false);
    }
  };

  const sendTest = async () => {
    try {
      const { data } = await api.post("/push/test");
      toast.success(data.message);
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <Card className="p-4 rounded-2xl" data-testid="push-settings-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-xl bg-secondary grid place-items-center"><BellRing className="h-4 w-4" /></div>
          <div>
            <p className="font-medium text-sm">Notifications push</p>
            <p className="text-xs text-muted-foreground">
              {!supported
                ? (iosHint ? "Sur iPhone/iPad : ajoutez l'app à l'écran d'accueil (Partager → Sur l'écran d'accueil) pour activer le push." : "Non pris en charge par ce navigateur.")
                : `Ventes, paiements et messages même app fermée${devices ? ` · ${devices} appareil${devices > 1 ? "s" : ""}` : ""}`}
            </p>
          </div>
        </div>
        <Switch checked={enabled} disabled={!supported || busy} onCheckedChange={toggle} data-testid="push-toggle" />
      </div>
      {enabled && (
        <Button variant="outline" size="sm" className="rounded-xl mt-3" onClick={sendTest} data-testid="push-test-button">Envoyer une notification de test</Button>
      )}
    </Card>
  );
};

export default PushSettings;
